import { Card, Container, Grid, Modal, Paper } from "@material-ui/core";
import { DataStore } from "aws-amplify";
import React, { Fragment, useEffect, useState } from "react";
import { Dataset, Process } from "../api/models";
import { DataPortalService, Role } from "../api/DataPortalService";
import DatasetAnalysis from "./blades/DatasetAnalysis";
import DatasetDetails from "./blades/DatasetDetails";
import DatasetFiles from "./blades/DatasetFiles";
import DatasetLineage from "./blades/DatasetLineage";
import DatasetLogs from "./blades/DatasetLogs";
import DatasetProcess from "./blades/DatasetProcess";
import DatasetTags from "./blades/DatasetTags";
import Header from "./blades/Header";

const PortalDataset: React.FC<any> = ({ theme, props }) => {
  const [project, setProject] = useState<any>(null);
  const [dataset, setDataset] = useState<any>(null);
  const [process, setProcess] = useState<any>(null);
  const [processes, setProcesses] = useState<Array<Process>>([]);
  const [files, setFiles] = useState<Array<any>>([]);
  const [logs, setLogs] = useState<any>(null);
  const [role, setRole] = useState<String>(Role.NONE);
  const [showLogs, setShowLogs] = useState(false);
  const [showParams, setShowParams] = useState(false);

  useEffect(() => {
    const subscription = DataStore.observe(Dataset).subscribe((msg) => {
      fetchData();
    });
    fetchData();
    return () => subscription.unsubscribe();
  }, []);

  async function fetchData() {
    const project = await DataPortalService.getProject(props.projectId);
    const dataset = await DataPortalService.getDataset(props.datasetId);
    const role = await DataPortalService.getRole(props.projectId);
    const logs = await DataPortalService.getLogs(dataset);
    const process = await DataPortalService.getProcess(dataset);
    const processes = await DataPortalService.getProcesses(process);
    const files = await DataPortalService.getDatasetFiles(
      props.projectId,
      props.datasetId
    );
    setProject(project);
    setDataset(dataset);
    setRole(role);
    setLogs(logs);
    setProcess(process);
    setProcesses(processes);
    setFiles(files);
  }

  if (!process) return <Fragment></Fragment>;

  return (
    <Container fixed style={{ paddingBottom: "60px" }}>
      <Header />
      <Grid container spacing={4} alignItems="stretch">
        <Grid item xs={12}>
          <DatasetDetails
            project={project}
            process={process}
            dataset={dataset}
          />
        </Grid>
        <Grid item xs={12}>
          <DatasetFiles dataset={dataset} project={project} files={files} />
        </Grid>
        <Grid item xs={12}>
          <DatasetAnalysis
            project={project}
            dataset={dataset}
            processes={processes}
          />
        </Grid>

        {/* <Grid item xs={12} lg={6}>
          <DatasetLogs process={process} logs={logs} />
        </Grid>
      */}
        <Grid item xs={12} lg={6}>
          <DatasetProcess
            project={project}
            dataset={dataset}
            process={process}
            onShowLogs={() => setShowLogs(true)}
            onShowParameters={() => setShowParams(true)}
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          <DatasetTags dataset={dataset} role={role} />
        </Grid>
      </Grid>
      <Modal
        open={showParams}
        onClose={() => setShowParams(false)}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <Paper
          style={{
            position: "absolute",
            border: "0px solid",
            width: "80%",
            height: "80%",
            top: "10%",
            left: "10%",
          }}
        >
          Params
        </Paper>
      </Modal>
      <Modal
        open={showLogs}
        onClose={() => setShowLogs(false)}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <Paper
          style={{
            position: "absolute",
            border: "0px solid",
            width: "80%",
            height: "80%",
            top: "10%",
            left: "10%",
          }}
        >
          Logs
        </Paper>
      </Modal>
    </Container>
  );
};

export default PortalDataset;
